import React from 'react';

// List of custom props that should NOT be passed to DOM elements
const customProps = [
  'tagId', 'tagValue', 'tagBinding', 'foreColor', 'isEditMode', 'previewMode',
  'colorMap', 'textColor', 'defaultColor', 'showZones', 'normalZoneEnd', 'warningZoneEnd',
  'customWidgetId', 'templateName', 'customComponents', 'customCanvasSize', 'customCanvasProps',
  'actionType', 'targetTagId', 'tagOperation', 'navigationTarget', 'workflowName',
  'workflowParameters', 'taskCommand', 'taskParameters', 'setValue', 'toggleValue',
  'enableWorkflow', 'enableLogging', 'watchdogTimeout', 'companyId', 'parentText',
  'isStatusLabel', 'originalOptions', 'numberFormat', 'refreshInterval', 'dataMode',
  'maxDataPoints', 'showGrid', 'showLegend', 'tagIds', 'hasValueBinding',
  'valueTextMap', 'textColorMap', 'valueMap', 'unit', 'fontWeight', 'fontFamily',
  'fontSize', 'min', 'max', 'value', 'text'
];

// Common widget wrapper that applies style properties
const WidgetWrapper = ({
  children,
  width,
  height,
  // Style properties
  backgroundColor = 'transparent',
  foreColor = '#000000',
  borderWidth = 0,
  borderColor = '#000000',
  borderRadius = 0,
  fontSize = 14,
  fontWeight = 400,
  fontFamily = 'inherit',
  opacity = 1,
  // Layout properties
  justifyContent = 'center',
  alignItems = 'center',
  padding = 0,
  ...otherProps
}) => {

  // Remove 'style' and custom props from otherProps to prevent them from being passed to DOM
  const { style: _, ...tempProps } = otherProps;

  // Filter out custom props that React doesn't recognize on DOM elements
  const restProps = {};
  Object.keys(tempProps).forEach(key => {
    if (!customProps.includes(key)) {
      restProps[key] = tempProps[key];
    }
  });

  const wrapperStyle = {
    width: '100%',
    height: '100%',
    backgroundColor,
    color: foreColor,
    border: borderWidth > 0 ? `${borderWidth}px solid ${borderColor}` : 'none',
    borderRadius: `${borderRadius}px`,
    fontSize: `${fontSize}px`,
    fontWeight,
    fontFamily,
    opacity,
    display: 'flex',
    alignItems,
    justifyContent,
    padding,
    overflow: 'hidden',
    boxSizing: 'border-box'
  };

  return (
    <div style={wrapperStyle} {...restProps}>
      {children}
    </div>
  );
};

export default WidgetWrapper;